import React from "react";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const footerNavigation = {
    product: [
      { name: "Solutions", href: "#" },
      { name: "Services", href: "#" },
      { name: "Methodology", href: "#" },
      { name: "Pricing", href: "#" },
    ],
    company: [
      { name: "About Us", href: "#" },
      { name: "Careers", href: "#" },
      { name: "Journal", href: "#" },
      { name: "Contact", href: "#" },
    ],
    legal: [
      { name: "Privacy Policy", href: "#" },
      { name: "Terms of Service", href: "#" },
      { name: "Cookie Policy", href: "#" },
    ],
  };

  return (
    <footer className="relative bg-[#080808] text-zinc-400 pt-24 pb-12 overflow-hidden">
      {/* Decorative Background Elements */}
      <div className="absolute top-0 left-1/4 w-px h-64 bg-gradient-to-b from-blue-500/20 via-transparent to-transparent" />
      <div className="absolute top-0 right-1/4 w-px h-64 bg-gradient-to-b from-purple-500/20 via-transparent to-transparent" />

      <div className="max-w-7xl mx-auto px-6 lg:px-12 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-16 lg:gap-8 mb-20">
          {/* Brand & Newsletter Section */}
          <div className="lg:col-span-5 space-y-8">
            <div className="flex items-center gap-3">
              <img
                src="https://566dev.com/566dev.svg"
                alt="566dev Logo"
                className="h-7 w-auto brightness-125"
              />
            </div>

            <div className="space-y-4">
              <h3 className="text-white text-lg font-medium">
                Subscribe to our newsletter
              </h3>
              <p className="text-sm text-zinc-500 max-w-sm">
                Get the latest insights on digital transformation and design
                delivered to your inbox.
              </p>
              <form className="flex max-w-md gap-2">
                <input
                  type="email"
                  placeholder="Enter your email"
                  className="flex-grow bg-white/5 border border-white/10 rounded-lg px-4 py-2.5 text-sm focus:outline-none focus:border-blue-500/50 transition-colors"
                />
                <button className="bg-white text-black px-5 py-2.5 rounded-lg text-sm font-semibold hover:bg-zinc-200 transition-colors">
                  Join
                </button>
              </form>
            </div>
          </div>

          {/* Navigation Links */}
          <div className="lg:col-span-7 grid grid-cols-2 md:grid-cols-3 gap-8">
            <div>
              <h4 className="text-white text-sm font-semibold mb-6 uppercase tracking-wider">
                Product
              </h4>
              <ul className="space-y-4">
                {footerNavigation.product.map((item) => (
                  <li key={item.name}>
                    <a
                      href={item.href}
                      className="text-sm hover:text-white transition-colors duration-200"
                    >
                      {item.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <h4 className="text-white text-sm font-semibold mb-6 uppercase tracking-wider">
                Company
              </h4>
              <ul className="space-y-4">
                {footerNavigation.company.map((item) => (
                  <li key={item.name}>
                    <a
                      href={item.href}
                      className="text-sm hover:text-white transition-colors duration-200"
                    >
                      {item.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
            <div className="col-span-2 md:col-span-1">
              <h4 className="text-white text-sm font-semibold mb-6 uppercase tracking-wider">
                Contact
              </h4>
              <div className="space-y-4 text-sm">
                <p>Tbilisi, Georgia</p>
                <a
                  href="tel:+995595548080"
                  className="block text-white font-medium hover:text-blue-400 transition-colors"
                >
                  +995 595 54 80 80
                </a>
                <a
                  href="mailto:hello@566dev.com"
                  className="block hover:text-white transition-colors"
                >
                  hello@566dev.com
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="pt-8 border-t border-white/5 flex flex-col md:flex-row justify-between items-center gap-6">
          <div className="flex flex-wrap justify-center md:justify-start gap-x-8 gap-y-2">
            {footerNavigation.legal.map((item) => (
              <a
                key={item.name}
                href={item.href}
                className="text-[11px] text-zinc-500 hover:text-zinc-300 transition-colors"
              >
                {item.name}
              </a>
            ))}
          </div>

          <div className="flex items-center gap-6">
            <p className="text-[11px] text-zinc-600">
              © {currentYear} 566dev Studio. Built for the future.
            </p>
          </div>
        </div>
      </div>

      {/* Aesthetic Light Glow */}
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-[1000px] h-[300px] bg-blue-600/5 blur-[120px] rounded-full pointer-events-none" />
    </footer>
  );
};

export default Footer;
